import React from "react";

import { GettingStartedWithUniFi } from "pages/Sections/GettingStartedWithUniFi";
import { MultiSiteDeployment } from "pages/Sections/GettingStartedWithUniFi/MultiSite";
import { MassiveScaleDeployment } from "pages/Sections/GettingStartedWithUniFi/MassiveScale";

import { getPageBasePaths } from "context/SiteSettingsContext/utils";
import { Route, Switch, withRouter } from "react-router-dom";
import withTracker from "util/withTracker";
import { RackMountedDeployment } from "pages/Sections/GettingStartedWithUniFi/RackMounted";

const RouteWrapper = () => {
  return (
    <Route path="/">
      <Switch>
        <Route
          path={getPageBasePaths("/how-it-works/multi-site")}
          exact
          render={() => <MultiSiteDeployment />}
        />
        <Route
          path={getPageBasePaths("/how-it-works/massive-scale")}
          exact
          render={() => <MassiveScaleDeployment />}
        />
        <Route
          path={getPageBasePaths("/how-it-works/large")}
          exact
          render={() => <RackMountedDeployment />}
        />
        <Route
          path={getPageBasePaths("/how-it-works")}
          exact
          render={() => <GettingStartedWithUniFi />}
        />
      </Switch>
    </Route>
  );
};

export default withRouter(withTracker(RouteWrapper));
